import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';

import { useNestedFilterSelectContext } from './context';
import styles from './nested-filter-select.module.css';

type NestedFilterSelectItemProps = {
  value: string;
  label: string;
  children?: ReactNode;
};

export function NestedFilterSelectItem({
  value,
  label,
  children,
}: NestedFilterSelectItemProps) {
  const { selectedValue, onSelectValue } = useNestedFilterSelectContext();
  const isSelected = value === selectedValue;

  return (
    <DropdownMenu.Item
      className={styles.item}
      data-selected={isSelected ? 'true' : undefined}
      data-testid={`data-builder-custom-filter-option-${value}`}
      onSelect={() => {
        onSelectValue(value);
      }}
    >
      <span className={styles.itemLabel}>{label}</span>
      {children !== undefined && children !== null ? (
        <span className={styles.endSlot}>{children}</span>
      ) : null}
    </DropdownMenu.Item>
  );
}
